import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, watch } from "vue";
import { gitHubApiStore, integrationsStore, jiraApiStore } from "@/hooks";
import {
  GitHubProjectInput,
  JiraProjectInput,
} from "@/components/integrations";


/**
 * Allows for configuring imports once a source has been selected.
 */
const __default__ = {
  name: "IntegrationSelector",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    source: {}
  },
  setup(__props: any) {

const props = __props;

/**
 * Reloads integrations data.
 */
function handleReloadIntegrations() {
  if (integrationsStore.validJiraCredentials) {
    jiraApiStore.handleLoadOrganizations();
  }
  if (integrationsStore.validGitHubCredentials) {
    gitHubApiStore.handleLoadProjects();
  }
}

onMounted(() => handleReloadIntegrations());

watch(
  () => [
    integrationsStore.validJiraCredentials,
    integrationsStore.validGitHubCredentials,
  ],
  () => handleReloadIntegrations()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.source === 'GitHub')
      ? (_openBlock(), _createBlock(_unref(GitHubProjectInput), { key: 0 }))
      : _createCommentVNode("", true),
    (props.source === 'Jira')
      ? (_openBlock(), _createBlock(_unref(JiraProjectInput), { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})